import { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Mail, HandHeart, Trash2, Check, Inbox } from "lucide-react";

export default function Messages() {
  const [items, setItems] = useState([]);

  const load = () => api.get("/contact-messages").then((r) => setItems(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const markRead = async (id) => { try { await api.put(`/contact-messages/${id}/read`); load(); } catch { toast.error("Failed"); } };
  const remove = async (id) => { try { await api.delete(`/contact-messages/${id}`); toast.success("Deleted"); load(); } catch { toast.error("Failed"); } };

  const unread = items.filter((m) => !m.read).length;

  return (
    <div className="space-y-6" data-testid="messages-page">
      <p className="text-sm text-[#526050]">{items.length} messages · <span className="text-[#D97706] font-medium">{unread} unread</span></p>

      <div className="space-y-4">
        {items.map((m) => (
          <Card key={m.id} className={`p-5 border shadow-sm ${m.read ? "bg-white border-[#E5E0D8]" : "bg-[#FFFDF6] border-[#f5e0a3]"}`} data-testid={`message-card-${m.id}`}>
            <div className="flex items-start justify-between gap-4">
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <Badge variant="outline" className={m.kind === "prayer" ? "bg-[#EAF2E8] text-[#2D5A27] border-[#cfe3cb]" : "bg-[#F3EFEA] text-[#526050] border-[#E5E0D8]"}>
                    {m.kind === "prayer" ? <HandHeart className="h-3 w-3 mr-1" /> : <Mail className="h-3 w-3 mr-1" />}
                    {m.kind === "prayer" ? "Prayer Request" : "Message"}
                  </Badge>
                  {!m.read && <span className="h-2 w-2 rounded-full bg-[#D97706]" />}
                  <span className="text-xs text-[#7A8A78]">{new Date(m.created_at).toLocaleString("en-NZ")}</span>
                </div>
                <p className="mt-2 font-medium text-[#1C241B]">{m.name} <span className="font-normal text-[#7A8A78]">· {m.email}</span></p>
                <p className="mt-1 text-sm text-[#526050] whitespace-pre-wrap">{m.message}</p>
              </div>
              <div className="flex flex-col gap-2 shrink-0">
                {!m.read && <Button size="icon" variant="ghost" className="h-8 w-8 text-[#2D5A27]" onClick={() => markRead(m.id)} data-testid={`read-message-${m.id}`}><Check className="h-4 w-4" /></Button>}
                <Button size="icon" variant="ghost" className="h-8 w-8 text-destructive" onClick={() => remove(m.id)} data-testid={`delete-message-${m.id}`}><Trash2 className="h-4 w-4" /></Button>
              </div>
            </div>
          </Card>
        ))}
        {items.length === 0 && (
          <div className="text-center py-16 text-[#7A8A78]">
            <Inbox className="h-10 w-10 mx-auto mb-3 opacity-50" />
            <p>No messages yet. Submissions from the public contact form will appear here.</p>
          </div>
        )}
      </div>
    </div>
  );
}
